import React from "react";
import { useNavigate } from "react-router-dom";
import "../Css/NeetHero.css";
import bg from "../assets/aaa.jpg";
import study from "../assets/study.png";
import girl from "../assets/girl.png";

import studentsImg from "../assets/group.jpg";
import book from "../assets/book.png";
import neetsyllabus from "../assets/neetsyllabus.png";
import neetpreparation from "../assets/neetpreparation.jpg";

import skilled from "../assets/skilled.png";
import Supportive from "../assets/Supportive.png";
import Education from "../assets/Education.png";
import Instruction from "../assets/Instruction.png";

import image from "../assets/image.png";


const NeetHero = () => {
  const navigate = useNavigate();

  return (
    <>
    <section
      className="neet-hero"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="neet-overlay"></div>

      <div className="neet-card">
        <span className="neet-tag">
          Trusted IITian's Guidance in Vadodara
        </span>

        <h1>
          Home Tuition for NEET & IIT-JEE in Vadodara
        </h1>

        <p>
          <strong>IITian'sChinmay Academy</strong> is a leading IIT JEE and NEET
          coaching institute in Vadodara, offering result-oriented home tuition
          for students who aspire to crack competitive exams. We understand that
          NEET and IIT-JEE demand strong conceptual clarity, disciplined study
          planning, and expert mentorship.
        </p>

        <p>
          Our experienced IITian faculty provide personalized home tuition,
          structured learning programs, regular assessments, and continuous
          performance tracking. With focused one-to-one guidance, we help
          students build confidence, master concepts, and achieve top results in
          NEET, JEE Mains, and JEE Advanced.
        </p>

        <button
          className="neet-btn"
          onClick={() => navigate("/contact")}
        >
          Enquire Now
        </button>
      </div>
    </section>


       <section className="why-choose-section">
  <h2 className="why-title">Why Choose IITian’s Chinmay Academy?</h2>

  <div className="why-grid">

    <div className="why-card">
      <img src={skilled} alt="IITian Faculty" />
      <h3>Expert IITian Faculty</h3>
      <p>
        IITian’s Chinmay Academy is led by highly experienced IITian faculty
        members who bring deep subject knowledge, exam-oriented teaching, and
        real IIT preparation insights. Our teachers focus on concept clarity,
        problem-solving skills, and competitive exam excellence.
      </p>
    </div>

    <div className="why-card">
      <img src={Supportive} alt="Personalized Coaching" />
      <h3>Personalized & Individual Attention</h3>
      <p>
        We believe every student learns differently. Our personalized teaching
        approach ensures one-to-one attention, customized study plans, and
        continuous doubt-solving support to maximize each student’s academic
        potential.
      </p>
    </div>

    <div className="why-card">
      <img src={Education} alt="Result Oriented Coaching" />
      <h3>Result-Oriented IIT-JEE & NEET Preparation</h3>
      <p>
        At IITian’s Chinmay Academy, we focus on disciplined preparation,
        structured curriculum, and regular assessments. Our proven teaching
        methodology helps students achieve top results in IIT-JEE (Mains &
        Advanced) and NEET.
      </p>
    </div>

    <div className="why-card">
      <img src={Instruction} alt="Free Demo Class" />
      <h3>Free Demo & Trusted Guidance</h3>
      <p>
        Experience our teaching quality with a free demo class. Our IITian
        mentors provide clear guidance, exam strategies, and continuous
        performance tracking to help students confidently move towards their
        IIT and medical career goals.
      </p>
    </div>

  </div>
</section>





        {/* ================= NEET COACHING INFO SECTION ================= */}
<section className="neet-info-section">
  <div className="neet-info-wrapper">

    {/* LEFT IMAGE */}
    <div className="neet-info-left">
      <img
        src={girl}
        alt="NEET Coaching Guidance"
      />
    </div>

    {/* RIGHT CONTENT */}
    <div className="neet-info-right">
      <h2>NEET Coaching</h2>
      <h3>What is NEET?</h3>

      <p>
        <strong>NEET (National Eligibility cum Entrance Test)</strong> is the
        national-level medical entrance examination in India for admission into
        MBBS, BDS, and other medical courses.
      </p>

      <p>
        NEET evaluates students on <strong>Physics, Chemistry, and Biology</strong>
        based on the NCERT syllabus. Success in NEET requires strong conceptual
        clarity, disciplined preparation, and expert mentorship.
      </p>

      <p>
        At <strong>IITian’s Chinmay Academy</strong>, we provide result-oriented
        NEET coaching with personalized guidance, regular assessments, and
        one-to-one support to help students achieve their medical dreams.
      </p>
    </div>
  </div>

  {/* WHY NEET */}
  <div className="neet-why-wrapper">
    <div className="neet-why-content">
      <h3>Why NEET?</h3>

      <p>
        NEET was introduced to create a transparent, fair, and uniform admission
        process for medical education across India. It replaced multiple entrance
        exams with a single standardized evaluation system.
      </p>

      <p>
        Clearing NEET opens doors to top government and private medical colleges.
        With proper guidance and focused preparation, students can secure
        admission to their dream medical institutions.
      </p>
    </div>

    <div className="neet-why-image">
      <img
        src={study}
        alt="Why Choose NEET Coaching"
      />
    </div>
  </div>
</section>

    <section className="neet-eligibility">
      <div className="neet-eligibility-wrapper">

        {/* LEFT CONTENT */}
        <div className="neet-eligibility-content">
          <h2>NEET Eligibility Criteria</h2>

          <p className="intro">
            Candidates must meet specific qualifying requirements in order to
            take the NEET exam:
          </p>

          <div className="eligibility-point">
            <h3>● Age Requirement</h3>
            <p>
              To be admitted, a candidate must be at least 17 years old or must
              have reached that age by December 31 of the admission year,
              whichever comes first.
            </p>
          </div>

          <div className="eligibility-point">
            <h3>● Academic Requirements</h3>
            <p>
              Candidates must have passed their 10+2 or equivalent examination
              with Physics, Chemistry, Biology/Biotechnology, and English as
              core subjects. A minimum aggregate of 50% is required
              (40% for SC/ST/OBC candidates).
            </p>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="neet-eligibility-image">
          <img src={studentsImg} alt="NEET Students Eligibility" />
        </div>

      </div>
    </section>
<hr/>
    <section className="neet-pattern-section">
      <h2 className="neet-pattern-title">
        NEET Exam Pattern for 2025–2026
      </h2>

      <div className="neet-pattern-wrapper">
        {/* LEFT IMAGE */}
        <div className="neet-pattern-image">
          <img src={book} alt="NEET Exam Pattern Book" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="neet-pattern-card">
          <p>
            The <strong>NEET paper-and-pencil test</strong> is a comprehensive
            examination that assesses knowledge in <strong>Physics, Chemistry,
            and Biology</strong>. It evaluates conceptual understanding and the
            ability to apply concepts to real-world scenarios.
          </p>

          <p>
            The exam duration is <strong>3 hours</strong>, allowing students to
            answer <strong>180 multiple-choice questions</strong>. NEET is a
            standardized national-level examination for admission into medical
            and dental colleges across India.
          </p>

          <ul>
            <li>45 questions in Physics</li>
            <li>45 questions in Chemistry</li>
            <li>90 questions in Biology (Botany & Zoology)</li>
          </ul>

          <p>
            Each correct answer carries <strong>4 marks</strong>, while each
            incorrect response results in <strong>-1 negative marking</strong>.
            This makes accuracy and conceptual clarity extremely important.
          </p>
        </div>
      </div>
    </section>

    <section className="neet-info-block">

  {/* ===== NEET SYLLABUS ===== */}
  <div className="neet-card-row">
    <div className="neet-card-left">
      <h2>NEET Syllabus</h2>
      <img src={neetsyllabus} />
    </div>

    <div className="neet-card-right">
      <p>
        Topics from classes 11 and 12 of the CBSE (Central Board of Secondary
        Education) curriculum are included in the NEET syllabus. The syllabus is
        designed to evaluate students’ knowledge and comprehension, ensuring
        they are adequately prepared for the medical entrance exam.
      </p>

      <ul>
        <li>Physics includes mechanics, optics, thermodynamics, and more.</li>
        <li>Chemistry includes physical, organic, and inorganic components.</li>
        <li>Biology includes zoology and botany.</li>
      </ul>
    </div>
  </div>

  {/* ===== NEET PREPARATION ===== */}
  <div className="neet-card-row">
    <div className="neet-card-left">
      <h2>NEET Preparation</h2>
      <img src={neetpreparation} alt="NEET Preparation" />
    </div>

    <div className="neet-card-right">
      <p>
        The best way to prepare for the NEET exam is with a well-organized study
        strategy, thorough study materials, and consistent practice.
      </p>

      <ul>
        <li>Understand the syllabus and exam format clearly.</li>
        <li>Use quality books, online resources, and study aids.</li>
        <li>Solve previous year papers and take mock tests regularly.</li>
        <li>Seek proper guidance from experienced mentors or coaching.</li>
      </ul>
    </div>
  </div>

</section>


            <section className="how-it-works">
  <h2 className="how-title">How It Works?</h2>

  <p className="how-desc">
    If you are looking for reliable <strong>NEET or IIT-JEE coaching in Vadodara</strong>,
    IITian’s Chinmay Academy is the right place for you. We combine expert IITian
    mentorship with a structured learning approach to help students achieve
    academic excellence.
    <br /><br />
    Our process is simple, transparent, and student-focused. From understanding
    individual learning needs to providing expert guidance and continuous
    performance tracking, we support students at every step of their
    IIT-JEE and NEET preparation journey.
  </p>

  <div className="how-content">
    {/* LEFT ILLUSTRATION */}
    <div className="how-image">
      <img src={image} alt="Contact IITian’s Chinmay Academy" />
    </div>

    {/* RIGHT CARD */}
    <div className="how-card">
      <h3>Give Us a Call</h3>

      <p>
        Call us to discuss your academic goals, subject requirements, and exam
        preparation needs. Our experts will guide you with the right coaching
        plan for IIT-JEE or NEET.
      </p>

      <a href="tel:+918849189845" className="how-phone">
        📞 +91 88491 89845
      </a>
    </div>
  </div>
</section>



    </>
  );
};

export default NeetHero;
